export default __webpack_public_path__ + "static/media/04_nested_unnested.e511b20b.png";